import { render, staticRenderFns } from "./LocationsTabs.vue?vue&type=template&id=82c1059c&"
import script from "./LocationsTabs.vue?vue&type=script&lang=js&"
export * from "./LocationsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports